export const SURVEY_STATUS = {
  NOT_STARTED: 0,
  STARTED: 1,
  COMPLETED: 2,
};
